import Vue from "vue";
import Router from "vue-router";

import LandingPage from './components/views/LandingPage'
import NewUserLanding from './components/views/NewUserLanding'
import MainPage from './components/views/MainPage'
import AdminSettings from './components/views/AdminSettings'
import AdminSettingsCircle from './components/views/AdminSettingsCircle'
import DashboardPage from './components/views/DashboardPage'
import CustomsDashboard from './components/views/CustomsDashboard'
import CustomsOperative from './components/views/CustomsOperative'
import PraticaDetailPage from '@/components/views/PraticaDetailPage'
import BookingTrial from '@/components/views/BookingTrial'
import TrackingPublicShare from '@/components/views/TrackingPublicShare'
import ShipmentLinkDashboard from './components/views/ShipmentLinkDashboard'
import ImportPage from './components/views/ImportPage'
import LandingPageCircle from './components/views/LandingPageCircle'
import RoadImportPage from "./components/views/RoadImportPage";
import HouseBLPage from "./components/elements/pratica/houseBL/HouseBLPage";
import ShipmentErrorsPage from "./components/elements/ContainerErrorsPage";

Vue.use(Router);

export const router = new Router({
  mode: "history",
  routes: [
    { path: "/", name: "landing", component: process.env.VUE_APP_USER_MANAGEMENT_PROVIDER === 'Azure' ? LandingPage : LandingPageCircle },
    {
      path: "/tracking/:uuid",
      name: "trackingShare",
      component: TrackingPublicShare,
      props: true,
    },
    {
      path: "/app",
      name: "main",
      component: MainPage,
      children: [
        { path: '', name: 'dashboard', component: DashboardPage, props: true },
        { path: 'settings', name: 'settings', component: process.env.VUE_APP_USER_MANAGEMENT_PROVIDER === 'Azure' ? AdminSettings : AdminSettingsCircle },
        { path: 'pratica/:id', name: 'pratica', component: PraticaDetailPage, props: true },
        // kept for old links: the detail page now depends on the company layout
        { path: 'et-pratica/:id', redirect: to => ({ name: 'pratica', params: { id: to.params.id } }) },
        { path: 'houseBl/:id', name: 'houseBl', component: HouseBLPage, props: true},
        { path: 'booking/:id', name: 'booking', component: BookingTrial, props: true },
        { path: 'newuser', name: 'newUserLanding', component: NewUserLanding },
        { path: 'customs/dashboard', name: 'customsDashboard', component: CustomsDashboard },
        { path: 'customs/import', name: 'import', component: ImportPage },
        { path: 'customs/operative', name: 'customsOperative', component: CustomsOperative },
        { path: "invoice-shipment-link", name: "invoiceShipmentsLink", component: ShipmentLinkDashboard },
        { path: 'dashboard/road-import', name: 'roadImport', component: RoadImportPage },
        { path: 'container-errors', name: 'containerErrors', component: ShipmentErrorsPage },
      ],
    },
    { path: "*", redirect: "/" },
  ],
});

router.beforeEach((to, from, next) => {
  const publicPages = ["/"];
  const authRequired = !publicPages.includes(to.path) && !to.path.includes("/tracking");
  const loggedIn = process.env.VUE_APP_USER_MANAGEMENT_PROVIDER === 'Azure' ? router.app.$msal.isAuthenticated() :  localStorage.getItem('user') && localStorage.getItem('authToken');
  if (authRequired && !loggedIn) {
    return next("/");
  }
  next();
});
